<template>
  <div>
    <v-card class="pl-5 pr-5">
      <h1>Publications</h1>
      <v-divider></v-divider>

      <div class="row">
        <div class="pl-3 col">
          <v-text-field
            id="search"
            v-model="Search"
            label="Search"
            required
            append-outer-icon="mdi-table-search"
            @click:append-outer="onSearch"
            v-on:keyup.enter="onSearch()"
          ></v-text-field>
        </div>
      </div>

      <div class="row">
        <div class="col">
          <v-simple-table>
            <template v-slot:default>
              <thead>
                <tr>
                  <th class="text-left">Title</th>
                  <th class="text-left">ISBN</th>
                  <th class="text-left">Author Name</th>
                  <th class="text-left">Publisher Name</th>
                  <th class="text-left">Collections</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="item in list" :key="item.id">
                  <td>{{ item.Title }}</td>
                  <td>{{ item.ISBN }}</td>
                  <td>{{ item.AuthorName }}</td>
                  <td>{{ item.PublisherName }}</td>
                  <td>
                    <div v-for="pub in item.publicationCollection" :key="pub.id">
                       {{pub.collections.Name}}
                    </div>
                  </td>
                </tr>
              </tbody>
            </template>
          </v-simple-table>
        </div>
      </div>
      <div class="row">
        <div class="col">
          <Pagination :paging="paging" v-on:next="onNextPage" />
        </div>
      </div>
    </v-card>
  </div>
</template>

<script>
import * as api from "@/api";
import Pagination from "@/components/Pagination";
export default {
  name: "OrgPublications",
  components: {
    Pagination,
  },
  created() {
    this.getPublicationByPagin();
  },
  methods: {
    onSearch() {
      this.paging.page = 1;
      this.paging.keyword = this.Search;
      this.getPublicationByPagin();
    },
    onNextPage(page) {
      console.log("onNextPage " + page);
      this.paging.page = page;
      this.paging.keyword = this.Search;
      this.getPublicationByPagin();
    },
    getPublicationByPagin() {
      this.list = [];
      new Promise((resolve, reject) => {
        api
          .postPaginByOrganization("publications", this.paging,0)
          .then((response) => {
            this.list = response.data.data;
            this.paging.count = response.data.count;
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
  },
  data: () => ({
    list: [],
    Search: "",
    paging: { count: 10, page: 1, size: 10, keyword: "" },
  }),
};
</script>


// WEBPACK FOOTER //
// src/views/Organization/OrgPublications.vue